import React, { useMemo, useState } from "react";

import AlertData, {
  SYSTEM_WRITE_MESSAGES_FILTER,
} from "../../api/AlertData";

import { observer } from "mobx-react-lite";

import { useNavigate } from "react-router-dom";

import ApiData from "../../api/ApiData";

import Loader from "../Loader";

import { FilterTagError } from "./FilterTagError";

import Media from "../../api/Media";

import User from "../../api/User";

import { BtnSearch } from "../tools/BtnSearch";

import { ContainerSubTitleGrey } from "../ContainerSubTitleGrey";

import {
  filterSubscriptionAlerts,
  formatValidityDate,
  getDaysUntilExpiry,
  resolveManagerForSubscriptionItem,
} from "../../utils/subscriptionAlertUtils";
import { readSystemMessagesSession } from "../../utils/systemMessagesSessionStorage";
import Msg from "../../api/Msg";

const GRID_CLASS = "cc-v4-soft-grid alert-subscription-grid";
const ALERT_SEARCH_PLACEHOLDER =
  "Поиск по ИНН, названию компании и ФИО менеджера…";

export const ErrorListAlert = observer(() => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const onClickLink = (inn) => {
    navigate(`/company/${inn}`);
  };

  const showSubscription =
    AlertData.active_report_subscription &&
    AlertData.filter_collection.find(
      (f) => f.name === "active_report_subscription",
    )?.active;

  const showSystemMessages = AlertData.filter_collection.find(
    (f) => f.name === SYSTEM_WRITE_MESSAGES_FILTER,
  )?.active;

  const systemMessageLogVersion = AlertData.counter_error + Msg.messages.length;
  const systemMessages = showSystemMessages
    ? readSystemMessagesSession().slice().reverse()
    : [];
  void systemMessageLogVersion;

  const filteredSubscriptions = useMemo(() => {
    return filterSubscriptionAlerts(AlertData.date_error_subscription, {
      hideExpired: AlertData.hide_expired_subscription_alert,
      showMineOnly: AlertData.alert_show_mine_only,
      searchQuery: search,
      currentUserId: User.user?.id,
      companys: ApiData.companys,
    });
  }, [
    AlertData.date_error_subscription,
    AlertData.hide_expired_subscription_alert,
    AlertData.alert_show_mine_only,
    search,
    User.user?.id,
    ApiData.companys,
  ]);

  if (AlertData.alert_loader) {
    return <Loader />;
  }

  const rawCount = AlertData.date_error_subscription.length;
  const showEmptyInTable =
    showSubscription && filteredSubscriptions.length === 0;
  const showEmptySystem =
    showSystemMessages && systemMessages.length === 0;
  const showEmptyNoData =
    !showSubscription &&
    !showSystemMessages &&
    rawCount === 0 &&
    systemMessages.length === 0;

  const formatSystemMessageTime = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleString("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="alert-center-content">
      {showSubscription ? (
        <>
          <div className="alert-center-tabs-toolbar reports-toolbar">
            <FilterTagError />
            <BtnSearch
              className="reports-search-input"
              placeholder={ALERT_SEARCH_PLACEHOLDER}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {showEmptyInTable ? (
            <ContainerSubTitleGrey text="Уведомления отсутствуют" />
          ) : (
            <div className="cc-v4-soft-list-root">
              <div className={`cc-v4-soft-header ${GRID_CLASS}`}>
                <span className="cc-v4-soft-th-static">
                  <span className="cc-v4-soft-th-label">Компания</span>
                </span>
                <span className="cc-v4-soft-th-static">
                  <span className="cc-v4-soft-th-label">ИНН</span>
                </span>
                <span className="cc-v4-soft-th-static reports-th-numeric">
                  <span className="cc-v4-soft-th-label">Осталось дней</span>
                </span>
                <span className="cc-v4-soft-th-static reports-th-numeric">
                  <span className="cc-v4-soft-th-label">Срок сгорания</span>
                </span>
                <span className="cc-v4-soft-th-static">
                  <span className="cc-v4-soft-th-label">
                    Ответственный менеджер
                  </span>
                </span>
              </div>
              <div className="cc-v4-soft-body">
                {filteredSubscriptions.map((a) => {
                  const manager = resolveManagerForSubscriptionItem(
                    a,
                    ApiData.companys,
                  );
                  const companyName = a.company_rel?.name_company ?? "—";
                  const displayName =
                    !Media.mobile || companyName.length <= 16
                      ? companyName
                      : `${companyName.slice(0, 16)}...`;
                  const validityDisplay = formatValidityDate(a.validity_date);

                  return (
                    <div
                      className={`cc-v4-soft-row ${GRID_CLASS} reports-soft-row`}
                      key={a.id ?? a.company_id}
                      onClick={() => onClickLink(a.company_rel.inn)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          onClickLink(a.company_rel.inn);
                        }
                      }}
                    >
                      <span className="reports-cell">{displayName}</span>
                      <span className="reports-cell company-card-v4-mono">
                        {a.company_rel.inn}
                      </span>
                      <span className="reports-cell reports-cell-numeric">
                        {getDaysUntilExpiry(a.validity_date)}
                      </span>
                      <span
                        className="reports-cell reports-cell-numeric"
                        title={a.validity_date || undefined}
                      >
                        {validityDisplay}
                      </span>
                      <span
                        className={`reports-cell${
                          manager.muted ? " reports-cell-muted" : ""
                        }`}
                      >
                        {manager.text}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </>
      ) : showSystemMessages ? (
        <>
          <FilterTagError />
          {showEmptySystem ? (
            <ContainerSubTitleGrey text="Уведомления отсутствуют" />
          ) : (
            <div className="cc-v4-soft-list-root alert-system-messages-list">
              <div className="cc-v4-soft-body">
                {systemMessages.map((entry) => (
                  <div
                    key={entry.id}
                    className="alert-system-message-row"
                  >
                    <p className="alert-system-message-text">{entry.message}</p>
                    <time
                      className="alert-system-message-time"
                      dateTime={entry.createdAt}
                    >
                      {formatSystemMessageTime(entry.createdAt)}
                    </time>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          <FilterTagError />
          {showEmptyNoData ? (
            <ContainerSubTitleGrey text="Уведомления отсутствуют" />
          ) : null}
        </>
      )}
    </div>
  );
});
